"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColorBright = exports.isColorDark = exports.getLightnessFromHexColor = void 0;
var getLightnessFromHexColor = function getLightnessFromHexColor(_ref) {
  var color = _ref.color;
  var rgb = parseInt(color.substring(1), 16);
  var r = rgb >> 16 & 0xff,
    g = rgb >> 8 & 0xff,
    b = rgb >> 0 & 0xff;
  var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luma / 255;
};
exports.getLightnessFromHexColor = getLightnessFromHexColor;
var isColorDark = function isColorDark(_ref2) {
  var color = _ref2.color;
  return getLightnessFromHexColor({
    color: color
  }) < 0.4;
};
exports.isColorDark = isColorDark;
var isColorBright = function isColorBright(_ref3) {
  var color = _ref3.color;
  return !isColorDark({
    color: color
  });
};
exports.isColorBright = isColorBright;